import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../../shared/modules/material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { OktaRoutingModule } from './okta-routing.module';

import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { EmailSentComponent } from './email-sent/email-sent.component';
import { ActivateUserComponent } from './activate-user/activate-user.component';
import { OktaService } from './okta.service';
import { VerifyTokenComponent } from './verify-token/verify-token.component';
import { AnswerComponent } from './security-question/answer/answer.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { UpdateComponent } from './security-question/update/update.component';
import { UnlockAccountComponent } from './unlock-account/unlock-account.component';
import { DirectiveModule } from '../../shared/modules/directive.module';
import { ExpiredPasswordComponent } from './expired-password/expired-password.component';

@NgModule({
  imports: [
    CommonModule,
    OktaRoutingModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    DirectiveModule
  ],
  declarations: [
    ForgotPasswordComponent,
    ResetPasswordComponent,
    EmailSentComponent,
    ActivateUserComponent,
    VerifyTokenComponent,
    AnswerComponent,
    ChangePasswordComponent,
    UpdateComponent,
    UnlockAccountComponent,
    ExpiredPasswordComponent
  ],
  providers: [OktaService]
})
export class OktaModule {}
